import { axiosClient } from 'www/utils'

export const getTownList = () => axiosClient.get('/api/town/menu/')

export const getTownsByQuery = (query: string) => {
  const url = '/api/town/autocomplete/'
  const queryParam = 'query='

  return axiosClient.get(`${url}?${queryParam}${query}`)
}
